import { Flame, ShieldCheck, Percent } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const cards = [
    {
        id: "lp",
        icon: Flame,
        title: "Liquidity Pool",
        value: "100% Burned",
        desc: "LP tokens sent to the eternal flame. Safe & immutable.",
        span: "lg:col-span-2",
        accent: "text-orange-400",
    },
    {
        id: "tax",
        icon: Percent,
        title: "Tax Policy",
        value: "0% / 0%",
        desc: "Zero buy tax. Zero sell tax. Pure decentralized trading.",
        span: "lg:col-span-2",
        accent: "text-emerald-400",
    },
    {
        id: "security",
        icon: ShieldCheck,
        title: "Contract Security",
        value: "Revoked & Immutable",
        desc: "Freeze authority revoked. Mint authority burned forever. The contract belongs to the haunted void now.",
        span: "lg:col-span-4",
        accent: "text-emerald-400",
    },
];

export const Tokenomics = () => (
    <section id="tokenomics" data-testid="tokenomics-section" className="relative z-10 mx-auto max-w-7xl px-5 py-28">
        <SectionHeading overline="No tricks, just treats" title="Haunted Tokenomics" sub="Fair launch on Solana — nothing up our sleeve" />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
            {cards.map((c, i) => (
                <Reveal key={c.id} delay={i * 0.12} className={`md:col-span-1 ${c.span}`}>
                    <div
                        data-testid={`tokenomics-card-${c.id}`}
                        className="group glass-panel h-full rounded-3xl p-8 transition-[box-shadow,border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-orange-400/50 hover:shadow-[0_0_40px_rgba(255,107,0,0.2)]"
                    >
                        <c.icon className={`mb-5 ${c.accent}`} size={30} strokeWidth={1.6} />
                        <p className="font-mono2 text-[10px] font-bold uppercase tracking-[0.25em] text-slate-500">{c.title}</p>
                        <p className={`font-heading mt-2 text-2xl font-extrabold sm:text-3xl ${c.accent}`}>{c.value}</p>
                        <p className="mt-3 text-sm leading-relaxed text-slate-400">{c.desc}</p>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);
